/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Aquishop : recherche instantanee. Toute requete de recherche predictive du theme (section predictive-search)
   passe par /search/suggest avec 6 resultats par type (limit_scope=each) : produits, categories, articles, pages.
   Le tri et les plafonds par type (6 / 4 / 3 / 2) sont faits dans sections/predictive-search.liquid. */
(function () {
  var TYPES = 'product,collection,article,page';
  var LIMIT = '6';

  function rewrite(input) {
    try {
      var url = new URL(input, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      if (url.searchParams.get('section_id') !== 'predictive-search') return null;
      var path = url.pathname;
      if (!/\/search(\/suggest)?$/.test(path)) return null;
      var q = url.searchParams.get('q') || '';
      if (q.indexOf('product_type:') !== -1) return null; /* filtre par type : on garde la recherche classique du theme */
      if (!/\/suggest$/.test(path)) {
        url.pathname = path + '/suggest';
        url.searchParams.delete('type');
        url.searchParams.delete('view');
        url.searchParams.delete('options[prefix]');
        url.searchParams.set('q', q.replace(/\*$/, ''));
      }
      url.searchParams.set('resources[type]', TYPES);
      url.searchParams.set('resources[limit]', LIMIT);
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      return url.pathname + url.search;
    } catch (e) {
      return null;
    }
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var raw = typeof input === 'string' ? input : (input && input.url);
      var next = raw ? rewrite(raw) : null;
      if (next) {
        input = typeof input === 'string' ? next : new Request(next, input);
      }
      return nativeFetch.call(this, input, init);
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var next = typeof url === 'string' ? rewrite(url) : null;
    if (next) arguments[1] = next;
    return nativeOpen.apply(this, arguments);
  };
})();
